import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Radio,
  RadioGroup,
  Stack,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useWatch } from "react-hook-form";
import { StyledLabel } from "../../../common/components/InputLabel";

const SpacingInput = ({ register, control, error, specificError }) => {
  const closeUpper = useWatch({ control, name: "closeUpperSpacing" });
  const closeLower = useWatch({ control, name: "closeLowerSpacing" });
  const messages = error
    ? Object.keys(error).map((key) => {
        const err = error[key];
        return err.message;
      })
    : [];

  return (
    <React.Fragment>
      <Grid item xs={3}>
        <StyledLabel error={!messages.every((err) => err === undefined)}>
          Spacing
        </StyledLabel>
        {messages.map((message, i) => (
          <FormHelperText key={i} error={true}>
            {message}
          </FormHelperText>
        ))}
      </Grid>
      <Grid item xs={9}>
        <Stack direction="row" spacing={6}>
          <FormControl>
            <Box id="upper-spacing-label" sx={{ fontWeight: 600 }}>
              Upper
            </Box>
            <RadioGroup
              aria-labelledby="upper-spacing-label"
              name="closeUppserSpacing"
            >
              <FormControlLabel
                value={true}
                control={<Radio {...register("closeUpperSpacing")} />}
                label="Close all spaces"
              />
              <FormControlLabel
                value={false}
                control={<Radio {...register("closeUpperSpacing")} />}
                label="Leave space/s"
              />
            </RadioGroup>
            {closeUpper === "false" ? (
              <TextField
                placeholder="Specify where"
                size="small"
                {...register("specificUpperSpacing")}
                error={Boolean(specificError.specificUpperSpacing)}
                helperText={specificError.specificUpperSpacing?.message}
              />
            ) : (
              <Box sx={{ width: "252px", height: "1px" }} />
            )}
          </FormControl>
          <FormControl>
            <Box id="lower-spacing-label" sx={{ fontWeight: 600 }}>
              Lower
            </Box>
            <RadioGroup
              aria-labelledby="lower-spacing-label"
              name="closeLowerSpacing"
            >
              <FormControlLabel
                value={true}
                control={<Radio {...register("closeLowerSpacing")} />}
                label="Close all spaces"
              />
              <FormControlLabel
                value={false}
                control={<Radio {...register("closeLowerSpacing")} />}
                label="Leave space/s"
              />
            </RadioGroup>
            {closeLower === "false" ? (
              <TextField
                placeholder="Specify where"
                size="small"
                {...register("specificLowerSpacing")}
                error={Boolean(specificError.specificLowerSpacing)}
                helperText={specificError.specificLowerSpacing?.message}
              />
            ) : ""}
          </FormControl>
        </Stack>
      </Grid>
    </React.Fragment>
  );
};

export default SpacingInput;
